<template>
  <v-chart :options="chartOptions" :autoresize="true" class="pie-chart" :style="{ height: height + 'px' }" />
</template>

<script>
import ECharts from "vue-echarts/dist/vue-echarts.js";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

const COLORS = ["#5b8ff9", "#5ad8a6", "#f2637b", "#e6b600", "#9270ca", "#ff9d4d", "#269a99"];

export default {
  name: "PieChart",
  components: {
    "v-chart": ECharts
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 280
    }
  },
  computed: {
    chartOptions() {
      const countByName = {};
      this.data.forEach(d => {
        countByName[d.name] = d.count || 0;
      });
      return {
        color: COLORS,
        tooltip: {
          trigger: "item",
          formatter(params) {
            return params.name + "<br/>" + params.marker + (params.value || 0).toLocaleString() + " (" + params.percent + "%)";
          }
        },
        legend: {
          orient: "vertical",
          right: 16,
          top: "middle",
          icon: "circle",
          itemGap: 12,
          textStyle: { color: "#606266", fontSize: 13 },
          formatter(name) {
            return name + "   " + (countByName[name] || 0).toLocaleString();
          }
        },
        series: [
          {
            type: "pie",
            radius: ["45%", "72%"],
            center: ["32%", "50%"],
            avoidLabelOverlap: true,
            label: { show: false },
            labelLine: { show: false },
            data: this.data.map(d => ({ name: d.name, value: d.count || 0 }))
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
.pie-chart {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLog/PieChart.vue